module.exports = __webpack_public_path__ + "static/media/291867.c09faf29.png";